module.exports = __webpack_public_path__ + "img/arrow_right_orange.cec6b22b.svg";